// extracted by mini-css-extract-plugin
export default {"zonesContainer":"ZonesAdmin_zonesContainer__Fw+Bq"};